import { render, staticRenderFns } from "./InsuranceTableWin.vue?vue&type=template&id=13a3a2db&scoped=true&"
import script from "./InsuranceTableWin.vue?vue&type=script&lang=js&"
export * from "./InsuranceTableWin.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceTableWin.vue?vue&type=style&index=0&id=13a3a2db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3a2db",
  null
  
)

export default component.exports